import Constants, { INPROGRESS_PAGE } from '../../../utils/Constants';
import image from '../../../assets/imgs/home/in_progress.webp';
import scrollToPage from '../../../utils/ScrollToLink';
import { Location, NavigateFunction } from 'react-router-dom';

const InProgress = ({
  location,
  navigate,
}: {
  location: Location;
  navigate: NavigateFunction;
}) => {
  return (
    <div id={Constants.INPROGRESS} className='inprogress'>
      <div className='inprogress_container container'>
        <div className='inprogress_container_text'>
          <h2 data-aos='fade-up' className='title_underline_light'>
            PROJEKT U IZGRADNJI
          </h2>
          <p data-aos='fade-up' data-aos-delay='50'>
            U izgradnji je stambeno-poslovni objekt sa dvije etaže podzemnih
            garaža povezanih direktno sa stanovima pomoću dizala, te prizemlja,
            4 kata i nadgrađa sa ukupno 168 stanova i 6 poslovnih prostora. U
            ponudi su garsonjere, jednosobni, dvosobni i trosobni stanovi te
            penthouse sa predivnom krovnom terasom.
          </p>
          <p data-aos='fade-up' data-aos-delay='100'>
            Stanovi i poslovni prostori prodaju se bez agencijske provizije i
            dodatnih poreza.
          </p>
          <p data-aos='fade-up' data-aos-delay='150'>
            Zgrade će biti energetskog razreda A
          </p>
          <a
            href={INPROGRESS_PAGE}
            data-aos='fade-up'
            data-aos-delay='200'
            className='button'
          >
            <div className='opacity_transition_low'>PRIKAŽI VIŠE</div>
          </a>
        </div>
        <div data-aos='fade-left' className='inprogress_container_img'>
          <div>
            <img src={image} alt='in finished home' />
          </div>
        </div>
      </div>
    </div>
  );
};
export default InProgress;
